export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  hostUser:process.env.NODE_ENV === 'production' ? 'https://school.aidprint.com' :  "http://frp2.frp.lfy0.com",
  baseUrl: {
    // dev: "http://frp2.frp.lfy0.com",
    dev: "http://192.168.0.193:3500",
    // dev: "https://www.xiaoxian.aidprint.com",
    pro: "https://www.xiaoxian.aidprint.com"
    // pro: "http://frp2.frp.lfy0.com",
  },

  // payment:'http://192.168.0.197:8080',//收款人资金管理后台
  payment:'https://merchant.aidprint.com',//收款人资金管理后台

  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: "home",
  /**
   * @description 需要加载的插件
   */
  plugin: {
    "error-store": {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: false // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  },
  ali: {
    app_id: "2016082901816914"
  },
  imgSrc: "https://www.xiaoxian.aidprint.com",
  errorImageHost: "https://www.xiaoxian.aidprint.com/img/error_icon/",
  oss: {
    accessKeyId: 'LTAIlhVlFVVRh6b2',
    secretAccessKey: 'Mb8du0Q2xu9ASLIiryOwjow2v7cbu5',
    bucket:"aidprintfile",
    region:"oss-cn-chengdu.aliyuncs.com",
  },
};
